<template>
  <div>
    <b-card no-body class="border-0">
      <b-card-body style="">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title" @click="filterVisible = !filterVisible" role="button">
            FILTER
          </div>
          <div class="title" @click="resetFilter" role="button">RESET</div>
        </div>
        <div class="row">
          <div class="col-md-2 mb-2">
            <filter-item :filter-column="resolveComponent('submitted_at__between')"></filter-item>
          </div>
          <div class="col-md-2 mb-2">
            <filter-item :filter-column="resolveComponent('partner_id__in')"></filter-item>
          </div>
          <div class="col-md-2 mb-2">
            <filter-item :filter-column="resolveComponent('processing_id__in')"></filter-item>
          </div>
          <div class="col-md-2 mb-2">
            <filter-item :filter-column="resolveComponent('status')"></filter-item>
          </div>
          <div class="col-md-2 mb-2">
            <filter-item :filter-column="resolveComponent('has_purchase_order')"></filter-item>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ModelFilter from "@/components/model-filter-v4";

export default {
  extends: ModelFilter,
  data() {
    return {
      filterVisible: false
    };
  }
};
</script>

<style scoped>
.multiselect__content-wrapper {
  height: 1000px !important;
}

.label-filter {
  font-weight: 600;
  font-size: 14px;
  color: #182230;
  margin-bottom: 5px;
}
</style>
